import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";

// 주문 수정 — 보낸 필드만 갱신된다(PUT, 서버가 model_fields_set 기준으로 처리).
// remitterName 은 입금 확인 전까지만 서버가 허용한다(이후엔 400).
// 환불 계좌 3필드는 함께 보내야 하고(일부만 오면 400) 환불 완료 전까지만 허용된다 —
// 취소된 주문도 환불 전이면 계좌는 고칠 수 있다.
export interface PathPickOrderUpdateRequestBody {
  remitterName?: string;
  shippingInfoId?: number;
  refundBankName?: string;
  refundAccountNumber?: string;
  refundAccountHolder?: string;
  // true면 수정한 계좌를 바이어 기본 환불 계좌로도 저장한다(다음 주문 자동 적용).
  saveRefundAccountAsDefault?: boolean;
}

// 주문 취소 — 부분 취소는 없고 주문 전체가 한 번에 취소된다.
// 사유는 선택 입력이라 비어 있으면 아예 보내지 않는다(서버가 null로 남긴다).
export interface PathPickOrderCancelRequestBody {
  cancelReason?: string;
}

const url = {
  updatePathPickOrder: (companyId: number, orderId: number) =>
    `/buyers/${companyId}/pathpick/orders/${orderId}`,
  cancelPathPickOrder: (companyId: number, orderId: number) =>
    `/buyers/${companyId}/pathpick/orders/${orderId}/cancel`,
};

export const pathPickOrderHistoryMutationApi = {
  updatePathPickOrder: async (
    companyId: number,
    orderId: number,
    body: PathPickOrderUpdateRequestBody
  ) => {
    const { data } = await axiosClient.put(
      url.updatePathPickOrder(companyId, orderId),
      toSnakeKeyObject(body)
    );
    return data;
  },

  cancelPathPickOrder: async (
    companyId: number,
    orderId: number,
    body: PathPickOrderCancelRequestBody
  ) => {
    const { data } = await axiosClient.put(
      url.cancelPathPickOrder(companyId, orderId),
      toSnakeKeyObject(body)
    );
    return data;
  },
};
